package org.catharsis.spendtel.feature.legal

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors

@Composable
fun LegalDocumentBody(
    document: LegalDocument,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(24.dp),
    ) {
        Text(
            text = "Last updated: ${document.lastUpdated}",
            style = MaterialTheme.typography.bodySmall,
            color = SpendTelReportColors.inkMuted,
        )

        document.sections.forEach { section ->
            LegalDocumentSection(section = section)
        }
    }
}

@Composable
private fun LegalDocumentSection(
    section: LegalSection,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        Text(
            text = section.title,
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.SemiBold,
            color = SpendTelReportColors.ink,
        )

        section.paragraphs.forEach { paragraph ->
            Text(
                text = paragraph,
                style = MaterialTheme.typography.bodyMedium,
                color = SpendTelReportColors.inkMuted,
                lineHeight = MaterialTheme.typography.bodyMedium.lineHeight,
            )
        }

        if (section.bullets.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                section.bullets.forEach { bullet ->
                    Text(
                        text = "• $bullet",
                        style = MaterialTheme.typography.bodyMedium,
                        color = SpendTelReportColors.inkMuted,
                        lineHeight = MaterialTheme.typography.bodyMedium.lineHeight,
                        modifier = Modifier.padding(start = 4.dp),
                    )
                }
            }
        }

        HorizontalDivider(
            modifier = Modifier.padding(top = 8.dp),
            color = SpendTelReportColors.inkMuted.copy(alpha = 0.12f),
        )
    }
}
